import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MusicNoteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"music_note"}/>
}
